import { server, YES } from "../constants";

import {
  HTTP_LOGIN_FETCHING,
  HTTP_LOGIN_SUCCESS,
  HTTP_LOGIN_FAILED,
} from "../constants/login";

import { httpClient } from "./../utils/HttpClient";

export const setLoginStateToFetching = () => ({
  type: HTTP_LOGIN_FETCHING,
});

export const setLoginStateToSuccess = (payload) => ({
  type: HTTP_LOGIN_SUCCESS,
  payload,
});

export const setLoginStateToFailed = () => ({
  type: HTTP_LOGIN_FAILED,
});

// export const isLoggedIn = () => {
//   return async () => {
//     if (localStorage.getItem("token")) 
//       localStorage.setItem(server.LOGIN_PASSED, YES);
//   };
// };

export const getSigninUrl = () => {
  return async (dispatch) => {
    const result = await httpClient.get(`/api/authentication/get-auth-url`);
    dispatch(setLoginStateToSuccess(result));
  };
};

export const getTokenFromCode = (queryParams) => {
  return async () => {
    await httpClient.post(`/api/authentication/generate-token`, {
      code: queryParams.code,
      state: queryParams.state,
    });
  };
};



